<template>
  <tr class="applicant-list" :style="bgColor">
    <td style="min-width: 40px!important;" class="text-center">
      <input
              type="checkbox"
              v-bind:value="applicantData.id"
              @change="checkUncheckJobseeker(applicantData.id)"
              :checked="isChecked" style="margin-top:4px;"
      />
    </td>
    <td
      style="padding-left:0px !important; min-width: 40px !important; max-width: 50px !important;"
      @click="showProfile"
    >{{rowNumber}}</td>
    <template>

      <td
        class="td-date text-center"
        @click="showProfile"
      >
      <div class="date-container d-flex flex-column align-items-center text-center">
        <span>{{ joinedDate }}</span><br/>
        <img 
          v-if="applicantData.companyFrom === '自社'" 
          :src="require('@/assets/images/Group 2418.svg')" 
          alt="自社HP経由登録"
          class="company-source-label"
        />
        <img 
          v-if="applicantData.eventParticipation"
          :src="require('@/assets/images/Group 2419.svg')" 
          alt="イベント申込済"
          class="company-source-label mt-2"
        />
        <!-- <span v-if="applicantData.eventParticipation" class="company-source event-source mt-2">イベント申込済 <span class="company-white"/></span> -->
      </div>
      </td>
      <td
        class="text-left"
        style="min-width: 150px !important; max-width: 150px !important;"
        @click="showProfile"
      >
        <div class="td-container d-flex flex-column">
          <span
            class="client-name"
            @click="showProfile"
            v-html="getHighlightedContent(['full_name', 'last_name'], `${applicantData.last_name} ${applicantData.name}`)"
            style="cursor: none;font-weight: bold;"
          ></span>
          <span>{{applicantData.age}} 歳/ {{employment.lastYearIncome}} 万円</span><br/>
          <span  v-html="getHighlightedContent(['graduation_school_name'], applicantData.education.instituteName)"/>
        </div>
      </td>

      <td
        class="text-left block-with-text"
        style="min-width: 150px !important; max-width: 150px !important;"
        @click="showProfile""
      >
      <div class="td-container d-flex flex-column">
        <span v-html="getHighlightedContent(['recent_registered_company_name'], employment.lastCompany)"></span><br/>
        <span> {{employment.lastJob.title}}/
          <br />
        ( {{employment.lastJob.child.title}} )</span>
      </div>

    </td> 

    <td class="text-left"  style="min-width: 250px !important; max-width: 250px !important;" @click=showProfile>
      <span
        class="scouted-jobs truncate-title"
        v-for="job in applicantData.scouted_jobs"
        :key="job.id"
        @click.stop="showProfile(job)"
      >
        {{ jobTitle(job) }} <br/> <span class="scouted-date" @click.stop>希望日: {{ formatScoutedDate(job.scoutedAt) }}</span>
      </span><br/>
    </td>
    <!-- <td class="text-left"  style="min-width: 190px !important; max-width: 190px !important;"  @click="showProfile">
      <p class="" v-for="job in applicantData.markedjobseekers" :key="job.id">{{jdTitle(job)}}</p>
    </td> -->
    <td class="text-right">
      <div class="d-flex justify-content-center note-btn-grp">
        <Favorite
          :favorite="applicantData.isFavorite"
          @click.native="toggleFavorite(applicantData)"
          :toggledisabled="loading"
        />
        <span class="ml-2"></span>
        <Memo v-bind:key="applicantData.id+applicantData.memo" :applicant="applicantData"/>
      </div>
    </td>
    <!-- <td class="text-left">
      <div class="d-flex flex-column align-items-center">
        <ScoutButton 
          :loading="isScoutLoading" 
          @click="checkJdAssigned('scout')" 
        />
        <button class="request-judgment" @click="checkJdAssigned('list')">{{judgementText}}</button>
      </div>
    </td> -->

    <td class="text-center status-cell" :class="{ 'status-pending': applicantData.status === '未判定' }">
      {{ applicantData.status }}
    </td>
  </template>
    <ProfileModal
      :applicantId="applicantData.id"
      :applicantIndex="applicantIndex"
      :isFavorite="applicantData.isFavorite"
      :isInterview="applicantData.isInterview"
      :applicantdata="applicantData"
      :showProfileModal="showProfileModal"
      :isPreview="isPreview"
      :isPendingReview="isPendingReview"
      v-on:hideModal="hideProfile"
    />
    <ReviewListPopup 
      ref="reviewListPopup" 
      :applicant="applicantData"
      :showReviewListModal="showReviewListModal"
      @hideModal="hideReviewList"
    />
    <ConfirmationPopup
      ref="confirmationPopUp"
      :modalText="detailsText"
      :buttonText="buttonText"
      @submit="processSubmission"
      @cancel="hideConfirmationModal"
      v-if="openConfirmationPopup"
    />
  </tr>
</template>

<script>
import Favorite from '@/components/dashboard/applicants/Favorite.vue';
import Interview from '@/components/dashboard/applicants/Interview.vue';
import ColorCategory from '@/components/dashboard/applicants/ColorCategory.vue';
import Memo from '@/components/dashboard/applicants/Memo.vue';
import ProfileModal from '@/components/dashboard/applicants/profile/ProfileModal.vue';
import StatusDropDown from '@/components/dashboard/StatusDropDown.vue';
import ScoutButton from '@/components/dashboard/ScoutButton.vue';
import ReviewListPopup from '@/components/dashboard/ReviewListPopup.vue';
import ConfirmationPopup from './profile/ConfirmationPopup.vue';
import Api from '@/config/api';
import ApiService from '@/service/apiService';
import moment from 'moment';
import { mapGetters, mapState, mapMutations } from 'vuex';

export default {
  name: 'ApplicantRow',
  components: {
    Memo,
    Favorite,
    Interview,
    ProfileModal,
    StatusDropDown,
    ColorCategory,
    ScoutButton,
    ReviewListPopup,
    ConfirmationPopup,
  },
  props: [
    'applicant',
    'applicantIndex',
    'rowNumber',
    // 'isChecked',
    'isPreview',
    'isPendingReview'
  ],
  data() {
    return {
      rowColor: this.applicant.color,
      applicantData: this.applicant,
      showProfileModal: false,
      loading: false,
      isCheckSome: false,
      showReviewListModal: false,
      openConfirmationPopup: false,
      option: '',
      isScoutLoading: false,
    };
  },
  computed: {
    ...mapGetters({
      getMenus: 'getMenus',
      isReviewer: 'isCreateReviewUser',
      isAdmin: 'currentUserIsAdmin',
      statusColorMap: 'getStatusColorMap'
    }),
    ...mapState({
      jobseekerIds: ({ applicant }) => applicant.jobseekerIds,
    }),
    detailsText() {
      if (this.option == 'list') {
        return 'スカウトする求人が選択されていません <br/> このまま判定を依頼しますか？';
      } else {
        return 'スカウトする求人が選択されていません<br/> このままスカウト候補へ追加しますか？';
      }
    },
    buttonText() {
      if (this.option == 'list') {
        return '判定を依頼する';
      } else {
        return 'スカウト候補へ追加';
      }
    },
    isChecked() {
      return this.jobseekerIds.includes(this.applicant.id)
    },
    // isApplicantRead() {
    //   return this.applicant.profile_view_status === 'read';
    // },
    bgColor() {
      // if(this.applicant.profile_view_status === 'read') {
      //   return 'background-color: #D9D9D9'
      // } else {
        return 'background-color:#fff';
      // }
    },
    judgementText() {
      return this.isPreview ? '対象から除外' : (this.isReviewer ? '判定を依頼する' : '対象から除外');
    },
    // bgColor() {
    //   let color;
    //   if (this.rowColor == '#fff') {
    //     color = '#fbfcff';
    //   } else {
    //     color = this.rowColor;
    //   }
    //   return `background-color: ${color}`;
    // },
    joinedDate() {
        return moment(this.applicantData.joinedDate)
        .utcOffset('+0900')
        .format('YYYY-MM-DD');    
    },
    reviewListAddedDate(){
      return moment(this.applicantData.reviewListAddedDate)
        .utcOffset('+0900')
        .format('YYYY-MM-DD');
    },
    checked() {
      return this.isChecked ? 'checked' : '';
    },
    employment() {
      return this.applicantData.employment;
    },
    imagePath() {
      return this.applicantData.imagePath;
    },
    colorClass() {
      const status = this.applicantData.status;
      const colorMap = this.statusColorMap;
      for(let color in colorMap){
        if(colorMap[color].includes(status)){
          return color;
        }
      }
      return '';
    },
  },

  methods: {
    ...mapMutations({
      mutateApplicantsAfterFav: 'mutateApplicantsAfterFav',
      mutateApplicantsAfterInterview: 'mutateApplicantsAfterInterview',
      checkUncheckJobseeker: 'checkUncheckJobseeker',
      setReloadApplicants: 'setReloadApplicants',
      mutateApplicantReadStatus: 'mutateApplicantReadStatus',
      setScoutedJd: 'setScoutedJd',
    }),
    jobTitle(job) {
      return job.jobDetails.job_title || '';
      // let jobTitle = job.jobDetails.job_title;
      // return jobTitle.length > 15 ? jobTitle.substring(0, 15) + '...' : jobTitle;
    },
    formatScoutedDate(date) {
      if (!date) return '';
      return moment(date)
        .utcOffset('+0900')
        .format('YYYY/MM/DD');
    },
    jdTitle(jd){
      return jd.jobDescriptionTitle;
    },
    async processSubmission() {
      this.openConfirmationPopup = false;
      if (this.option == 'list') {
        this.requestJudgement();
      } else {
        await this.toggleScout();
      }
    },
    hideConfirmationModal() {
      this.openConfirmationPopup = false;
      // this.$refs.confirmationModal.close();
    },
    async checkJdAssigned(option) {
      // Handle preview and non-reviewer cases first
      if (option === 'list' && (this.isPreview || !this.isReviewer)) {
        this.requestJudgement();
        return;
      }

      const hasMarkedJobseekers = this.applicantData.markedjobseekers.length > 0;
      
      if (!hasMarkedJobseekers) {
        this.option = option;
        this.openConfirmationPopup = true;
        return;
      }

      if (option === 'list') {
        this.requestJudgement();
      } else {
        await this.toggleScout();
      }
    },
    async toggleScout() {
      try {
        this.isScoutLoading = true;
        await ApiService.put(Api.endpoints.CLIENT_STATUS_CHANGE(this.applicant.id), {
          status: 'スカウト対象',
          isNewPanel: true
        });
        this.setReloadApplicants(true);
      } catch (error) {
        console.log(error);
        this.parseErrorResponse(error.response);
      } finally {
        this.isScoutLoading = false;
      }
    },
    requestJudgement() {
      if (this.isPreview || !this.isReviewer) {
        this.removeFromReviewList();
        return;
      }
      this.showReviewListModal = true;
    },
    removeFromReviewList(){
        this.loading = true
        ApiService.put(Api.endpoints.REMOVE_FROM_REVIEW_LIST(this.applicant.id))
        .then(({ data }) => {
          this.setReloadApplicants(true);
        })
        .catch((error) => console.log(error))
        .then(() => {
          this.loading = false;
      });
    },
    hideReviewList() {
      this.showReviewListModal = false;
    },
    getHighlightedContent(paths, originalText) {
      if (!this.applicantData.highlights || !this.applicantData.highlights.length) {
        return originalText;
      }

      // Special handling for name fields
      if (paths.includes('last_name') || paths.includes('full_name')) {
        let highlightedText = originalText;

        const nameHighlights = this.applicantData.highlights.filter(h => 
          paths.includes(h.path) && h.texts && h.texts.length
        );

        for (let highlight of nameHighlights) {
          // Sort hit texts by length (longest first) to handle overlapping matches
          const hitTexts = highlight.texts
            .filter(t => t.type === 'hit')
            .sort((a, b) => b.value.length - a.value.length);

          // Process each hit text separately
          for (let hitText of hitTexts) {
            const searchRegex = new RegExp(this.escapeRegExp(hitText.value), 'gi');
            highlightedText = highlightedText.replace(
              searchRegex, 
              match => `<span class="highlight-hit">${match}</span>`
            );
          }
        }

        return highlightedText;
      }

      // Regular handling for other fields
      const highlights = this.applicantData.highlights.filter(h => paths.includes(h.path));
      if (highlights.length === 0) {
        return originalText;
      }

      let highlightedText = originalText;

      for (let highlight of highlights) {
        // Sort hit texts by length (longest first) to handle overlapping matches
        const hitTexts = highlight.texts
          .filter(t => t.type === 'hit')
          .sort((a, b) => b.value.length - a.value.length);

        // Process each hit text separately
        for (let hitText of hitTexts) {
          const searchRegex = new RegExp(this.escapeRegExp(hitText.value), 'gi');
          highlightedText = highlightedText.replace(
            searchRegex, 
            match => `<span class="highlight-hit">${match}</span>`
          );
        }
      }

      return highlightedText;
    },
    escapeRegExp(string) {
      return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    },
    formatHighlightText(texts) {
      return texts.map(text => {
        if (text.type === 'hit' || text.type === 'text') {
          return `<span class="highlight-hit">${text.value}</span>`;
        }
        return text.value;
      }).join('');
    },
    changeRowColor(color) {
      this.rowColor = color;
    },
    toggleFavorite(applicant) {      
      this.loading = true;
      const method = applicant.isFavorite ? 'delete' : 'put';
      ApiService[method](Api.endpoints.FAVORITE(applicant.id))
        .then(({ data }) => {
          // this.applicantData = data.data;
          this.mutateApplicantsAfterFav(data.data);
        })
        .catch(({ response }) => this.parseErrorResponse(response))
        .then(() => {
          this.loading = false;
        });
    },

    toggleInterview(applicant) { 
      this.loading = true;
      const method = applicant.isInterview ? 'delete' : 'put';
      ApiService[method](Api.endpoints.INTERVIEW(applicant.id))
              .then(({ data }) => {
        // this.applicantData = data.data;
      this.mutateApplicantsAfterInterview(data.data);
    })
    .catch(({ response }) => this.parseErrorResponse(response))
    .then(() => {
        this.loading = false;
    });
    },
    // async toggleReadStats(status='read') {
    //   try {
    //     const statusToUpdate = status === 'read' ? 'read' : 'unread';

    //     const {data} = await ApiService.put(Api.endpoints.MARK_APPLICANT_READ(this.applicantData.id), {
    //       status: statusToUpdate
    //     });
    //     const response = data.data;
    //     if(response){
    //       this.applicantData.profile_view_status = statusToUpdate;
    //     }
    //     this.mutateApplicantReadStatus({
    //       id: this.applicantData.id,
    //       profile_view_status: statusToUpdate
    //     });
    //   } catch (error) {
    //     console.error('Error marking applicant as read:', error);
    //     // Failed to mark as read, but user can still view profile
    //   }
    // },
    showProfile(job=null) {
      this.showProfileModal = true;
      if(job) {
        this.setScoutedJd(job.jobDetails)
      }
      // this.toggleReadStats();
    },
    hideProfile() {
      this.showProfileModal = false;
    },
    statusChanged(status) {
      this.applicantData.status = status;
    },
    logout() {
      this.$router.push('/logout');
    },
  },
  watch: {
    'applicant': {
      handler(newApplicant) {
        // Only update fields that need highlighting
        const fieldsToUpdate = {
          highlights: newApplicant.highlights,
          last_name: newApplicant.last_name,
          name: newApplicant.name,
          education: newApplicant.education,
          employment: newApplicant.employment
        };
        
        Object.assign(this.applicantData, fieldsToUpdate);
      },
      deep: false
    },
    'applicant.status': function () {
      this.applicantData.status = this.applicant.status;
    },
    'applicant.isFavorite': function () {
      this.applicantData.isFavorite = this.applicant.isFavorite;
    },
    'applicant.isInterview': function () {
      this.applicantData.isInterview = this.applicant.isInterview;
    },
    'applicant.memo': function () {
      this.applicantData.memo = this.applicant.memo;
    },
    'applicant.markedjobseekers': function(newVal) {
      // console.log(newVal);
      this.applicantData.markedjobseekers = newVal;
    }
  },
};
</script>

<style scoped>
.truncate-title {
  display: inline-block;
  max-width: 90%;
  white-space: nowrap;   /* keep in one line */
  overflow: hidden;      /* cut off overflow */
  text-overflow: ellipsis; /* show ... */
  vertical-align: bottom;
}

.btn-read i{
  color: #3C3C3C;
  background-color: #fff;
}
.scouted-jobs {
  /* font-size: 12px; */
  color: #036AC9;
  display: block;
}
.note-btn-grp button {
  width: 20px;
}
.client-listing-detail tr:hover {

}
.status-cell {
  font-weight: bold;
  font-size: 16px;
}
.status-cell.status-pending {
  color: #EB5757;
}

</style>
<style>

.company-source-label {
  width: 122px !important;
  height: 30px !important;
  object-fit: contain;
  margin-right: 12px;
}

.highlight-hit{
  background-color: #ffd700 !important;
  padding: 0 2px;
  border-radius: 2px;
  font-weight: 500;
}
.pink button {
  color: #fff;
  background-color: #b97070;
  border-color: #b97070;
}
.grey button {
  color: #fff;
  background-color: #ab8371;
  border-color: #ab8371;
}
.green button {
  color: #fff;
  background-color: #5bb55b;
  border-color: #5bb55b;
}
.lightblue button {
  color: #fff;
  background-color: #7070af;
  border-color: #7070af;
}
.lightgreen button {
  color: #fff;
  background-color: #7ba27b;
  border-color: #7ba27b;
}
.red button {
  color: #fff;
  background-color: #ab8371;
  border-color: #ab8371;
}
.yellow button{
  color: #000;
  background-color: #ffea00;
  border-color: #ffea00;
}

.applicant-list td {
  padding: 5px 7px !important;
  border-bottom: 1px solid #787878;
}

.applicant-list:hover {
  /*border-right: solid 2px #0e0e0e6b;*/
  /*border-left: solid 2px #0e0e0e6b;*/
  /*box-shadow:rgba(50, 52, 93, 0) 1px 0px 20px 4px inset, rgb(0 0 0 / 10%) 0px 0px 20px 0px inset;*/

  /*-webkit-box-shadow: rgba(67, 71, 85, 0.27) 0px 0px 0.25em, rgba(90, 125, 188, 0.05) 0px 0.25em 1em;*/
  /*-moz-box-shadow: rgba(67, 71, 85, 0.27) 0px 0px 0.25em, rgba(90, 125, 188, 0.05) 0px 0.25em 1em;*/
  /*box-shadow: */
  box-shadow: rgba(67, 71, 85, 0.27) 0px 0px 0.25em, rgba(90, 125, 188, 0.05) 0px 0.25em 1em;
  z-index: 1;
  /*background-color: #f0f5f7!important;*/

  border: 2px solid #036d6c;
  /*background-color: #F0F8FD!important;*/

}
.pink button:hover,
.show.pink button {
  background-color: white !important;
  color: black !important;
  border-color: #b97070 !important;
}
.grey button:hover,
.show.grey button {
  background-color: white !important;
  color: black !important;
  border-color: #ab8371 !important;
}
.green button:hover,
.show.grey button {
  background-color: white !important;
  color: black !important;
  border-color: #5bb55b !important;
}
.lightblue button:hover,
.show.lightblue button {
  background-color: white !important;
  color: black !important;
  border-color: #7070af !important;
}
.lightgreen button:hover,
.show.lightgreen button {
  background-color: white !important;
  color: black !important;
  border-color: #7ba27b !important;
}

.yellow button:hover,
.show.yellow button {
  background-color: white !important;
  color: black !important;
  border-color: #ffea00 !important;
}

.wrapword {
  white-space: -moz-pre-wrap !important; /* Mozilla, since 1999 */
  white-space: -pre-wrap; /* Opera 4-6 */
  white-space: -o-pre-wrap; /* Opera 7 */
  white-space: pre-wrap; /* css-3 */
  word-wrap: break-word; /* Internet Explorer 5.5+ */
  white-space: -webkit-pre-wrap; /* Newer versions of Chrome/Safari*/
  word-break: break-all;
  white-space: normal;
}

.block-with-text {
  /* hide text if it more than N lines  */
  overflow: hidden;
  /* for set '...' in absolute position */
  position: relative; 
  /* use this value to count block height */
  line-height: 1.2em;
  /* max-height = line-height (1.2) * lines max number (3) */
  max-height: 3.6em; 
  /* fix problem when last visible word doesn't adjoin right side  */
  text-align: justify;  
  /* place for '...' */
  margin-right: -1em;
  padding-right: 1em;
}
.text-center {
  min-width: 50px !important;
}

.applicant-list >td:hover {
  /*font-weight:600!important;*/
  /*text-decoration: underline;*/
  color:#1e6d6b!important;
}
.note-btn-grp >.btn-heart i:hover{
  color:#aba2a2!important;
}
.fa-sticky-note:hover{
  color:#aba2a2!important;
}
.client-listing-detail table td:first-child {
  min-width:25px!important;
}
.client-listing-detail table td:last-child {
  min-width:25px!important;
}

.scouted-date {
  cursor: default;
  color: #3c3c3c;
  text-decoration: none;
  pointer-events: none;
  display: block;
  text-align: center;
  width: 100%;
  margin: 0 auto;
}

</style>

